export type EntityLinkVariant = 'outlined' | 'text';

export type EntityLinkSize = 'small' | 'medium' | 'large';

export type EntityLinkAction = 'drawer' | 'navigate' | 'none';

const getBaseSize = (size: EntityLinkSize): number => {
  switch (size) {
    case 'small':
      return 20;
    case 'medium':
      return 24;
    case 'large':
      return 28;
    default:
      return 16;
  }
};

export const computeIconSize = (size: EntityLinkSize, hasSubtext: boolean): number => {
  const baseSize = getBaseSize(size);
  if (hasSubtext) {
    return baseSize + 4;
  }
  return baseSize;
};
